<nv-header [logoHref]="logoHref">
  <nv-user-login-button *ngIf="!showLoginLogoutButton()"></nv-user-login-button>
  <nv-user-logout-button *ngIf="!showLoginLogoutButton()" class="ms-3" [showTitle]="false"></nv-user-logout-button>
</nv-header>
